import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { organizationVideoQueryKeys } from './queryKeys';

export const archiveOrganizationVideo = async (organizationVideoId: number) => {
  const response = await EXPRESS_API.patch(
    `/organization-videos/${organizationVideoId}/archive`
  );
  return response.data;
};

export const useArchiveOrganizationVideoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (organizationVideoId: number) =>
      archiveOrganizationVideo(organizationVideoId),
    {
      onSuccess: async () => {
        successToast({
          title: `Organization Video successfully deleted!`,
        });
        await queryClient.invalidateQueries(organizationVideoQueryKeys.all);
      },
    }
  );
};
